import MomentUtils from '@date-io/moment';
import '@fake-db';
import FuseAuthorization from '@fuse/core/FuseAuthorization';
import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import history from '@history';
import { createGenerateClassName, jssPreset, StylesProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { create } from 'jss';
import jssExtend from 'jss-plugin-extend';
import rtl from 'jss-rtl';
import React, {useEffect} from 'react';
import Provider from 'react-redux/es/components/Provider';
import { Router } from 'react-router-dom';
import AppContext from './AppContext';
import { Auth } from './auth';
import routes from './fuse-configs/routesConfig';
import store from './store';
import SimpleReactLightbox from 'simple-react-lightbox'
import { Notifications } from 'react-push-notification';
//import PageLoadTimeDisplay from './PageLoadTimeDisplay'

console.error = (function(_error) {
	return function(message) {
	  if (typeof message !== 'string' || message.indexOf('component is `contentEditable`') === -1) {
		_error.apply(console, arguments)
	  }
	}
  })(console.error)
  
const jss = create({
	...jssPreset(),
	plugins: [...jssPreset().plugins, jssExtend(), rtl()],
	insertionPoint: document.getElementById('jss-insertion-point')
});

const generateClassName = createGenerateClassName();



const App = () => {

	useEffect(() => {
		window.process = {
		  ...window.process,
		};
	}, []);

	/*useEffect(() => {
		if (window.location.origin !== "http://localhost:3000" && window.location.origin !== "http://127.0.0.1:3000"){
			console.log("should not be displayed in local",window.location.origin)
			axios.get(`http://ec2-18-183-224-13.ap-northeast-1.compute.amazonaws.com`)
				.then(res => {
					const dataFromServer = res.data;
					this.setState({ data: dataFromServer });
			});
		}
	});*/

	return (
			<AppContext.Provider
				value={{
					routes
				}}
			>
					<Notifications />
					{/*<PageLoadTimeDisplay />*/}
					<SimpleReactLightbox>
						<StylesProvider jss={jss} generateClassName={generateClassName}>
							<Provider store={store}>
									<MuiPickersUtilsProvider utils={MomentUtils}>
										<Auth>
											<Router history={history}>
												<FuseAuthorization>
													<FuseTheme>
														<FuseLayout />
													</FuseTheme>
												</FuseAuthorization>
											</Router>
										</Auth>
									</MuiPickersUtilsProvider>
							</Provider>
						</StylesProvider>
					</SimpleReactLightbox>
				
			</AppContext.Provider>
	
	);
};

export default App;
